var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoInfopopHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 107,
    viewBox: "0 0 179 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_731_8123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 70.87V22.68C0 10.2 10.2 0 22.68 0H76.72V48.19C76.72 60.66 66.52 70.87 54.04 70.87H0Z",
    fill: "#4CB2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.68 8.5C14.86 8.5 8.51001 14.86 8.51001 22.67V62.36H54.04C61.85 62.36 68.21 56 68.21 48.19V8.5H22.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.42 53.27H21.23V30.77H25.42V53.27V53.27Z",
    fill: "#4CB2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.96 30.77H54.15V53.27H47.19L37.9 34.46H37.75L38.1 53.27H33.91V30.77H40.84L50.19 49.58H50.31L49.96 30.77Z",
    fill: "#4CB2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41998 87.02H0.039978V106.12H3.41998V87.02Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.06 102.22L13.68 87.02H9.44V106.11H12.81V90.91L28.19 106.11H32.44V87.02H29.06V102.22Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.39 106.11H41.76V97.79H55.57V94.79H41.76V90.02H56.13V87.02H38.39V106.11Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.59 86.8201H67.47C62.67 86.8201 60.71 88.9301 60.71 94.0901V99.0401C60.71 104.21 62.67 106.31 67.47 106.31H77.59C82.39 106.31 84.35 104.2 84.35 99.0401V94.0901C84.35 88.9201 82.39 86.8201 77.59 86.8201ZM80.97 93.1701V99.9701C80.97 102.35 79.92 103.32 77.35 103.32H67.72C65.15 103.32 64.1 102.35 64.1 99.9701V93.1701C64.1 90.7901 65.15 89.8201 67.72 89.8201H77.35C79.92 89.8201 80.97 90.7901 80.97 93.1701Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.06 87.02H104.1V106.12H107.48V99H118.6C124.18 99 124.58 96.53 124.58 92.45C124.58 87.93 122.47 87.03 119.06 87.03V87.02ZM107.48 90.02H118.5C120.55 90.02 121.2 90.55 121.2 92.19V93.91C121.2 95.38 120.47 95.98 118.69 95.98H107.47V90.01L107.48 90.02Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.73 86.8201H135.61C130.81 86.8201 128.85 88.9301 128.85 94.0901V99.0401C128.85 104.21 130.81 106.31 135.61 106.31H145.73C150.53 106.31 152.49 104.2 152.49 99.0401V94.0901C152.49 88.9201 150.53 86.8201 145.73 86.8201ZM149.11 93.1701V99.9701C149.11 102.35 148.06 103.32 145.49 103.32H135.86C133.29 103.32 132.24 102.35 132.24 99.9701V93.1701C132.24 90.7901 133.29 89.8201 135.86 89.8201H145.49C148.06 89.8201 149.11 90.7901 149.11 93.1701Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.08 87.02H158.12V106.12H161.5V99H172.62C178.2 99 178.6 96.53 178.6 92.45C178.6 87.93 176.49 87.03 173.08 87.03V87.02ZM161.5 90.02H172.52C174.57 90.02 175.22 90.55 175.22 92.19V93.91C175.22 95.38 174.49 95.98 172.71 95.98H161.49V90.01L161.5 90.02Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_731_8123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178.6,
    height: 106.31,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInfopopHeader);
export default __webpack_public_path__ + "static/media/logo_infopop_header.d78f0d924711b7405d6734fb4978eebe.svg";
export { ForwardRef as ReactComponent };